import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/t/document-templates/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'createdOn', sortDir: 'desc' }),
  staticData: { breadcrumb: 'Document Templates', breadcrumbKey: 'K_BREADCRUMB_DOCUMENT_TEMPLATES' },
});
